module.exports = __webpack_public_path__ + "static/muli-v16-latin-regular-81bcb3d5d021099399d3f8837394009c.svg";